import { boatAPI, trailerAPI, componentAPI, inspectionAPI, oilAPI } from 'api/requests';

import { ROLES } from './roles'

export const METRICS = {
  [ROLES.COMPONENT_MANUFACTURER.serverName]: [
    {name:'New Applications', resultText:'Components created this month', withYear:false, withMonth:true, requestPath:componentAPI.newComponentsCount}
  ],
  [ROLES.BOAT_MANUFACTURER.serverName]: [
    {name:'New Boats', resultText:'Boats created this month', withYear:true, withMonth:true, requestPath:boatAPI.newBoatsCount},
    {name:'New Inspections', resultText:'Boat inspections created this month', withYear:true, withMonth:true, requestPath:inspectionAPI.newBoatInspectionsCount},
    {name:'Approved Boats', resultText:'Boats approved for Active Manufacturers as of now', withYear:true, withMonth:false, requestPath:boatAPI.approvedActiveBoatsCount},
    {name:'Certified Boats', resultText:'Boats certified as of now', withYear:true, withMonth:false, requestPath:boatAPI.approvedCertifiedBoatsCount},
    {name:'Active Brands', resultText:'Brands active as of now', withYear:true, withMonth:false, requestPath:boatAPI.getActiveBrandsCount},
    {name:'Certified Brands', resultText:'Brands certified as of now', withYear:true, withMonth:false, requestPath:boatAPI.getCertifiedBrandsCount},
  ],
  [ROLES.TRAILER_MANUFACTURER.serverName]: [
    {name:'New Trailers', resultText:'Trailers created this month', withYear:true, withMonth:true, requestPath:trailerAPI.newTrailersCount},
    {name:'New Inspections', resultText:'Trailer inspections created this month', withYear:true, withMonth:true, requestPath:inspectionAPI.newTrailerInspectionsCount},
  ],
  [ROLES.OIL_BRANDER.serverName]: [
    {name:'New brands', resultText:'Brands created this month', withYear:true, withMonth:true, requestPath:oilAPI.newOilBrandsCount},
    {
      name: 'Active Oil Brands',
      resultText:'',
      withYear: true,
      withMonth: false,
      requestPath: null,
      downloadPath: oilAPI.downloadActiveOilReport,
      downloadFileName: (accountCode, modelYear) => `Active_Oil_Brands_${accountCode}_${modelYear}.xlsx`
    },
  ],
  [ROLES.OIL_MANUFACTURER.serverName]: [
    {name:'New brands', resultText:'Brands created this month', withYear:true, withMonth:true, requestPath:oilAPI.newOilBrandsCount},
    {
      name: 'Active Oil Brands',
      resultText:'',
      withYear: true,
      withMonth: false,
      requestPath: null,
      downloadPath: oilAPI.downloadActiveOilReport,
      downloadFileName: (accountCode, modelYear) => `Active_Oil_Brands_${accountCode}_${modelYear}.xlsx`
    },
    {
      name: 'Active Oil Formulations',
      resultText:'',
      withYear: true,
      withMonth: false,
      requestPath: null,
      downloadPath: oilAPI.downloadActiveOilFormulationsReport,
      downloadFileName: (accountCode, modelYear) => `Active_Oil_Formulations_${accountCode}_${modelYear}.xlsx`
    },
  ],
};



// WEBPACK FOOTER //
// ./src/app/constants/metrics.js